import { render, staticRenderFns } from "./DefaultDialog.vue?vue&type=template&id=0535ed34"
import script from "./DefaultDialog.vue?vue&type=script&lang=js"
export * from "./DefaultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports